module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2023-11-20 at 11.31.23 AM.7fc0f408.jpeg";